export default __webpack_public_path__ + "static/media/horizontal-loading-indicator-default.852a435d.gif";